import { render, staticRenderFns } from "./DistributorLanding.vue?vue&type=template&id=12e12b5e&scoped=true"
import script from "./DistributorLanding.vue?vue&type=script&lang=js"
export * from "./DistributorLanding.vue?vue&type=script&lang=js"
import style0 from "./DistributorLanding.vue?vue&type=style&index=0&id=12e12b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e12b5e",
  null
  
)

export default component.exports